import React from "react";
import classNames from "classnames";

import Link from "../Link";
import Reveal from "../Reveal";

import { slugify } from "../../util";

const ns = `job-board`;

const JobBoard = ({ items = [] }) => {
  const rootClassnames = classNames({
    [`${ns}`]: true,
  });

  // Prospect gh_id retrieved from Greenhouse dashboard https://app.greenhouse.io/jobboard/5049
  const prospects = [
    {
      title: "Don't see a role you are seeking?",
      gh_id: "3241112",
    },
    {
      title: "Interested in Freelance Opportunities?",
      gh_id: "7141222",
    },
  ];

  const departmentsMarkup = items?.reduce((acc, cur) => {
    const { id: dptId, name, jobs } = cur;

    if (jobs?.length) {
      const jobsMarkup = jobs.map((job, i) => {
        const { id: jobId, title, location } = job;

        return (
          <li key={jobId}>
            {i === 0 ? (
              <div>
                <p>Open Roles</p>
              </div>
            ) : (
              <div></div>
            )}

            <div>
              <Link to={`/careers/${slugify(title)}`}>{title}</Link>
            </div>
            <div>
              <p>{location.name}</p>
            </div>
          </li>
        );
      });

      const component = (
        <li key={dptId}>
          <h3 className={`${ns}__department-name h3-reg`}>{name}</h3>
          <ul className={`${ns}__jobs`}>{jobsMarkup}</ul>
        </li>
      );

      acc.push(component);
    }

    return acc;
  }, []);

  const prospectsMarkup = prospects.map((prospect) => (
    <li key={prospect.gh_id}>
      <Link to={`/careers/${slugify(prospect.title)}`}>{prospect.title}</Link>
    </li>
  ));

  const contentMarkup = departmentsMarkup?.length ? (
    departmentsMarkup
  ) : (
    <h2 className={`${ns}__department-empty`}>
      There are no job postings at this time.
    </h2>
  );

  return (
    <section className={rootClassnames}>
      <div className={`container container--offset`}>
        <Reveal>
          <ul className={`${ns}__departments`}>
            {/* Open Roles */}
            {contentMarkup}

            {/* General inquiries */}
            <li>
              <h3 className={`${ns}__department-name h3-reg`}>
                General Inquiries
              </h3>

              <ul className={`${ns}__prospects`}>{prospectsMarkup}</ul>
            </li>
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default JobBoard;
